import IconTab1 from './Tab1';
import IconTab2 from './Tab2';
import IconTab3 from './Tab3';
import IconTab4 from './Tab4';
import IconTab5 from './Tab5';
import AgenticControlIcon from './AgenticControl';
import UnifiedIcon from './Unified';
import ZeroTrustIcon from './ZeroTrust';

export {
  IconTab1,
  IconTab2,
  IconTab3,
  IconTab4,
  IconTab5,
  AgenticControlIcon,
  UnifiedIcon,
  ZeroTrustIcon,
};
